import styles from "./styles.module.scss";
import { FC, useEffect, useMemo, useState, useRef, useContext } from "react";
import { Props } from "./typings";
import casesService from "api/casesService";
import { IEntity } from "dto/IEntity";
import { useDebounce } from "use-debounce";
import Input from "components/Input";
import DropdownInput from "components/DropdownInput";
import SignalsContext from "contexts/SignalsContext";
import ModalsManagerContext from "contexts/ModalsManager";

const SearchEntities: FC<Props> = ({
  label,
  doNotRemove = false,
  onChoose,
  className,
  isError = "",
  removeFocus,
  onRightClick,
  onRightText,
  disableBorder = false,
  showCreateEntity = true,
  onlyUsers = false,
}) => {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  const [value, setValue] = useState("");
  const [searchValue] = useDebounce(value, 300);
  const [searchList, setSearchList] = useState<IEntity[]>([]);
  const { data: entitiesData } = casesService.useGetAddressBook(
    searchValue,
    null,
    null,
    onlyUsers
  );
  const entities: IEntity[] = useMemo(
    () => entitiesData?.data ?? [],
    [entitiesData]
  );

  useEffect(() => {
    setSearchList(entities);
  }, [entities]);

  useEffect(() => {
    if (!value.length) {
      setSearchList(entities);
      return;
    }

    // const filters = entities.filter(
    //   (c) =>
    //     c?.Client?.search(value) !== -1 ||
    //     c?.Title?.search(value) !== -1 ||
    //     c?.Signature?.search(value) !== -1
    // );
    // setSearchList(entities);
  }, [value]);

  const handleClick = (id: string) => {
    console.log("odpalam");
    const cas = searchList.find((c) => c.Id === id);
    if (doNotRemove) {
      setValue(cas.Label ?? "");
    } else {
      setValue("");
    }
    setActive(false);
    onChoose?.(cas);
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      //@ts-ignore
      if (ref.current && !ref.current.contains(event.target as Element)) {
        setActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  const { modals, setModals } = useContext(ModalsManagerContext);
  const { parent, setChildren, callback, setCallback } =
    useContext(SignalsContext);

  useEffect(() => {
    if (!callback) return;
    if (callback?.Kind === 1024) return;
    const c = callback as IEntity;
    console.log(c);
    setValue(c.Label ?? c.Name ?? "");
    onChoose?.(c);
    setCallback(null);
  }, [callback]);

  const handleCreateNewEntity = () => {
    if (!parent) {
      setModals({ ...modals, createEntity: true, hide: false });
      return;
    }
    setChildren("createEntity");
  };

  return (
    <div ref={ref} className={`${styles.wrapper} ${className}`}>
      <div className={styles.focus}>
        <Input
          onRightClick={
            showCreateEntity
              ? onRightClick
                ? onRightClick
                : handleCreateNewEntity
              : null
          }
          onRightText={onRightText ? onRightText : "Nowy podmiot"}
          focus={removeFocus ? false : true}
          onFocus={() => setActive(true)}
          // onBlur={() => setActive(false)}
          value={value}
          isError={isError}
          onChange={(text) => setValue(text)}
          label={label ? label : "Podmioty"}
          disableBorder={disableBorder}
        />
      </div>

      {active && (
        <DropdownInput
          toggle={() => setActive(false)}
          items={searchList.map((c) => ({
            id: c.Id,
            title: c.Label,
            sub: c.Address,
          }))}
          onClick={(id) => handleClick(id)}
        />
      )}
    </div>
  );
};

export default SearchEntities;
